/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 22.01.13, 16:29
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class GGSTextAlign {
    public static CENTER: string = "center";
    public static END: string = "end";
    public static JUSTIFY: string = "justify";
    public static LEFT: string = "left";
    public static RIGHT: string = "right";
    public static START: string = "start";
}
